interface ParsedIds {
  accountId?: string;
  businessId?: string;
}

export const extractIdsFromUrl = (url: string): ParsedIds => {
  // Match pattern: /dashboard/accounts/{accountId}/{anything} or /dashboard/accounts/{accountId}/businesses/{businessId}
  const pattern =
    /\/dashboard\/accounts\/([^/]+)(?:\/businesses\/([^/]+))?(?:\/.*)?$/;
  const matches = url.match(pattern);

  if (!matches) {
    return {};
  }

  return {
    accountId: matches[1],
    businessId: matches[2] || undefined,
  };
};

export const replaceBusinessId = (url: string, businessId: string) => {
  const { businessId: currentBusinessId } = extractIdsFromUrl(url);
  if (!currentBusinessId) {
    return url;
  }
  return url.replace(currentBusinessId, businessId);
};
